export default __webpack_public_path__ + "static/media/nifty50-whythisshift-graph.6e2872f3.jpg";